import React, { useState } from 'react';
import './RecoveryModal.css';

interface RecoveryModalProps {
  open: boolean;
  onClose: () => void;
}

const RecoveryModal: React.FC<RecoveryModalProps> = ({ open, onClose }) => {
  const [step, setStep] = useState<'seed' | 'new-password'>('seed');
  const [formData, setFormData] = useState({
    seedPhrase: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [showSeedPhrase, setShowSeedPhrase] = useState(false);
  const [error, setError] = useState('');

  if (!open) return null;

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const validateSeedPhrase = () => {
    const words = formData.seedPhrase.trim().split(' ');
    if (words.length !== 12) {
      setError('La frase semilla debe tener exactamente 12 palabras');
      return false;
    }
    // Aquí iría la validación real con la base de datos
    setStep('new-password');
    return true;
  };

  const handleRecovery = (e: React.FormEvent) => {
    e.preventDefault();
    if (formData.newPassword !== formData.confirmPassword) {
      setError('Las contraseñas no coinciden');
      return;
    }
    if (formData.newPassword.length < 8) {
      setError('La contraseña debe tener al menos 8 caracteres');
      return;
    }
    
    console.log('Recuperación de contraseña:', formData);
    alert('Contraseña actualizada exitosamente');
    onClose();
  };

  const handleBack = () => {
    setStep('seed');
    setFormData({
      seedPhrase: '',
      newPassword: '',
      confirmPassword: ''
    });
    setError('');
  };

  return (
    <div className="recovery-modal-overlay" onClick={onClose}>
      <div className="recovery-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="recovery-container">
          <div className="recovery-header">
            <button className="recovery-close" onClick={onClose}>&times;</button>
            <h1>Recuperar Contraseña</h1>
            <p>Usa tu frase semilla para recuperar el acceso a tu wallet</p>
          </div>

          {step === 'seed' ? (
            <form onSubmit={(e) => { e.preventDefault(); validateSeedPhrase(); }}>
              <div className="seed-recovery-section">
                <div className="warning-box">
                  <i className="fas fa-exclamation-triangle"></i>
                  <h3>⚠️ Importante</h3>
                  <p>Solo podrás recuperar tu contraseña si tienes tu frase semilla de 12 palabras. Esta es la única forma de recuperar el acceso.</p>
                </div>

                <div className="seed-input-section">
                  <label>Frase Semilla (12 palabras):</label>
                  <div className="seed-input-container">
                    <textarea
                      name="seedPhrase"
                      value={formData.seedPhrase}
                      onChange={handleInputChange}
                      placeholder="Ingresa las 12 palabras de tu frase semilla separadas por espacios"
                      className="seed-phrase-textarea"
                      rows={4}
                    />
                    <button 
                      type="button" 
                      className="toggle-btn"
                      onClick={() => setShowSeedPhrase(!showSeedPhrase)}
                    >
                      <i className={`fas fa-${showSeedPhrase ? 'eye-slash' : 'eye'}`}></i>
                    </button>
                  </div>
                  <small>Ejemplo: bitcoin ethereum wallet secure private key crypto blockchain digital asset money future</small>
                </div>

                {error && <div className="error-message">{error}</div>}

                <div className="recovery-buttons">
                  <button type="button" className="btn-secondary" onClick={onClose}>
                    Cancelar
                  </button>
                  <button type="submit" className="btn-primary">
                    Verificar Frase Semilla
                  </button>
                </div>
              </div>
            </form>
          ) : (
            <form onSubmit={handleRecovery}>
              <div className="new-password-section">
                <div className="success-box">
                  <i className="fas fa-check-circle"></i>
                  <h3>✅ Frase Semilla Verificada</h3>
                  <p>Tu frase semilla es correcta. Ahora establece una nueva contraseña para tu wallet.</p>
                </div>

                <div className="password-input-section">
                  <label>Nueva Contraseña:</label>
                  <input 
                    type="password" 
                    name="newPassword"
                    value={formData.newPassword}
                    onChange={handleInputChange}
                    placeholder="Nueva contraseña"
                    required
                  />
                  
                  <label>Confirmar Nueva Contraseña:</label>
                  <input 
                    type="password" 
                    name="confirmPassword"
                    value={formData.confirmPassword}
                    onChange={handleInputChange}
                    placeholder="Confirmar nueva contraseña"
                    required
                  />
                </div>

                {error && <div className="error-message">{error}</div>}

                <div className="recovery-buttons">
                  <button type="button" className="btn-secondary" onClick={handleBack}>
                    Volver
                  </button>
                  <button type="submit" className="btn-primary">
                    Actualizar Contraseña
                  </button>
                </div>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default RecoveryModal; 